/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircle from '@mui/icons-material/CheckCircle';



export default function SimpleSnackbar(props) {
  const action = (
    <>
      <IconButton
        id="btn-snackbar-close"
        size="small"
        aria-label="close"
        color="inherit"
        onClick={props.close}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  // Check if message has newlines for multi-line display
  const hasMultipleLines = props.snackbarTitle && props.snackbarTitle?.includes('\n');
  const messageLines = hasMultipleLines ? props.snackbarTitle.split('\n') : [props.snackbarTitle];

  return (
    <div>
      {/* <Snackbar
        anchorOrigin={props.anchorOrigin || { vertical: 'top', horizontal: 'right' }}
        open={props.open}
        autoHideDuration={props.autoHideDuration || 5000}
        onClose={props.close}
        action={action}
        ContentProps={{
          sx: {
            backgroundColor:
            //  eslint-disable-next-line no-nested-ternary 
              props.snackbarType === "success"
                ? "#2E7D32"
                : props.snackbarType === "error"
                  ? "#D32F2F"
                  : "#323232",
            color: "#fff",
            borderRadius: "8px",
            padding: hasMultipleLines ? "12px 16px" : "8px 16px",
            fontWeight: 500,
            display: "flex",
            alignItems: hasMultipleLines ? "flex-start" : "center",
            gap: "10px",
            minWidth: hasMultipleLines ? "350px" : "auto",
            maxWidth: "500px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
        }} */}
      <Snackbar
        anchorOrigin={
          props.comingfrom === "login"
            ? { vertical: "bottom", horizontal: "center" }
            : props.anchorOrigin || { vertical: "top", horizontal: "right" }
        }
        open={props.open}
        autoHideDuration={props.autoHideDuration || 5000}
        onClose={props.close}
        action={action}
        sx={
          props.comingfrom === "login"
            ? { bottom: 40 }
            : {}
        }
        ContentProps={{
          sx: {
            backgroundColor:
              props.snackbarType === "success"
                ? "#2E7D32"
                : props.snackbarType === "error"
                  ? "#D32F2F"
                  : "#323232",
            color: "#fff",
            borderRadius: "8px",
            padding: "6px 16px",
            fontWeight: 500,
            display: "flex",
            alignItems: hasMultipleLines ? "flex-start" : "center",
            gap: "10px",
            minWidth: hasMultipleLines ? "350px" : "auto",
            maxWidth: "500px",
            minHeight: 'unset !important',
            flexWrap: 'nowrap !important',
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            ...(props.comingfrom === "login" ? {
              '& .MuiSnackbarContent-message': {
                padding: '0px !important',
              },
              '& .MuiSnackbarContent-action': {
                paddingLeft: '8px !important',
                marginRight: '0px !important',
              },
            } : {}),
          },
        }}
        message={
          hasMultipleLines ? (
            // Multi-line message display
            <span style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              width: "100%"
            }}>
              {props.snackbarType === "success" && (
                <CheckCircle sx={{ color: "white", fontSize: 24, marginTop: "2px", flexShrink: 0 }} />
              )}
              {props.snackbarType === "error" && (
                <ErrorIcon sx={{ color: "white", fontSize: 24, marginTop: "2px", flexShrink: 0 }} />
              )}
              <span style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "6px"
              }}>
                {messageLines.map((line, index) => (
                  <span
                    key={index}
                    style={{
                      display: "block",
                      fontSize: index === 0 ? "14px" : "13px",
                      fontWeight: index === 0 ? 600 : 400,
                      lineHeight: "1.4"
                    }}
                  >
                    {line}
                  </span>
                ))}
              </span>
            </span>
          ) : (
            // Single-line message display (original style)
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {props.snackbarType === "success" && (
                <CheckCircle sx={{ color: "white", fontSize: 22 }} />
              )}
              {props.snackbarType === "error" && (
                <ErrorIcon sx={{ color: "white", fontSize: 22 }} />
              )}
              <span style={{ fontSize: "14px", ...(props.comingfrom === 'login' && { whiteSpace: 'nowrap' }) }}>{props.snackbarTitle}</span>
            </span>
          )
        }
      />
    </div>
  );
}